'use strict';

var trackingUtils = require('../utils/tracking.utils');

module.exports = Odigeo.View.extend({
    selectors: {
        selectRoot: '.select_root',
        dropdownItem: '.accommodation_item',
    },

    events: {
        'click .selection_container': 'onClickSelectorExpander',
        'click .accommodation_item': 'onClickItem',
    },

    init() {
        this.onBlur = this.onBlur.bind(this);
        this.$el.on('updateFilterStatus.accommodationfilter', Odigeo._.bind(this.model.updateFilterStatus, this.model));
        this.$el.on('resetFilterStatus.accommodationfilter', Odigeo._.bind(this.cleanOurSelectionFilter, this));
        this.$container = $(this.widget.options.container);
        this.listenTo(this.model, 'change:isOurSelection', this.OnChangeSelected);
    },

    renderTemplate() {
        const selected = this.model.get('isOurSelection') ? this.keys.hotelOurSelection : this.keys.hotelAll;
        this.setTemplate(this.$el, 'accommodationOurSelection', {
            selected,
        });
    },

    onClickSelectorExpander() {
        this.toggle();
    },

    toggle() {
        var $selectorExpanderIcon = this.$el.find(this.selectors.selectRoot);
        var hasToOpen = this.model.get('opened');
        var isBlur = this.model.get('blur');
        if (!hasToOpen && isBlur === false) {
            trackingUtils.trackEvent('results_filters_hotels', 'unfold_hotels_list');
            this.$container.on(Odigeo.Events.click, this.onBlur);
        } else {
            this.$container.off(Odigeo.Events.click, this.onBlur);
        }
        $selectorExpanderIcon.toggleClass('focus', !hasToOpen);
        this.model.set('opened', !hasToOpen);
    },

    sendToFather(msg) {
        this.$el.trigger('filterHasChanged.accommodationfilter', msg);
    },

    onClickItem(event) {
        var selected = $(event.currentTarget);
        var value = selected.data().value;
        this.sendToFather({
            ourSelectionFilterModel: [{
                isOurSelection: value,
            }],
        });
        this.model.set('blur', false);
        this.toggle();
        this.$cachedSelectors.dropdownItem.removeClass('active');
        selected.addClass('active');
        var whichOption = value ? 'odigeoconnect' : 'all';
        trackingUtils.trackEvent('results_filters_hotels', 'hotels_list_select_' + whichOption);
    },

    OnChangeSelected() {
        this.renderTemplate();
    },

    onBlur(e) {
        var targetClassName = e.target.className;
        var isBlurOverAccomodationDropdown = targetClassName.indexOf('accommodation_dropdown') !== -1;
        var isBlurOverAccomodationItem = targetClassName.indexOf('accommodation_item') !== -1;
        var isBlurOverSelectionContainer = targetClassName.indexOf('selection_container') !== -1;
        var isRestFilterTag = targetClassName.indexOf('reset_filter_tag') !== -1;
        if (!isBlurOverAccomodationDropdown && !isBlurOverAccomodationItem && !isBlurOverSelectionContainer && !isRestFilterTag) {
            this.model.set('blur', true);
            this.toggle();
            this.model.set('blur', false);
        }
    },

    cleanOurSelectionFilter() {
        this.model.set('blur', false);
        this.model.set('opened', false);
        this.sendToFather({
            ourSelectionFilterModel: [{
                isOurSelection: false,
            }],
        });
    },

    checkContainsOurSelection(containsOurSelection) {
        if (containsOurSelection && !this.model.get('isRendered')) {
            this.renderTemplate();
            this.model.set('isRendered', true);
        }
        this.$container.find('.filter_our_selection_container').toggleClass('odf-hidden', !containsOurSelection);
    },
});
